import Vue from 'vue';
import callRequestBabyloan from './call-request-babyloan.vue';
import { mediaQueries } from '../../../common/media-query/media-query';
import { setPayload } from '../../../common/call-request-api/call-request-api';
import i18n from '../../../common/i18n/i18n';
window.addEventListener('call-request-init', ()=>{
	if (!window.customElements.get('call-request-component-blo')) {
		Vue.customElement('call-request-component-blo', callRequestBabyloan, {
			beforeCreateVueInstance(RootComponentDefinition) {
				RootComponentDefinition.mediaQueries = mediaQueries;
				RootComponentDefinition.i18n = i18n;
				return RootComponentDefinition;
			},
			destroyTimeout: 100
		});
		const event = new CustomEvent('call-request-blo-ready');
		window.dispatchEvent(event);
	}
});
window.addEventListener('call-request-blo-set-payload', setPayload);
